"use client";

import { useState } from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";

import PageContent from "@/components/page-content";
import { Button } from "@/components/ui/button";
import { ContactFormDialog } from "@/components/contact-form-dialog";

export function SolutionCTA({ finetuneSlug }: { finetuneSlug: string }) {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <PageContent>
      <div className="rounded-xl border bg-card p-8 md:p-12 text-center space-y-6">
        <h2
          className="text-2xl tracking-tight md:text-3xl"
          style={{ fontFamily: "var(--font-instrument-serif)" }}
        >
          Ready to build your solution?
        </h2>
        <p className="text-muted-foreground max-w-xl mx-auto">
          Talk to our team about how Moondream can solve your specific vision AI
          challenge, from model training through production deployment.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button size="lg" onClick={() => setContactOpen(true)}>
            Talk to Sales
          </Button>
          <Button variant="outline" size="lg" asChild>
            <Link href={`/ft/${finetuneSlug}`}>
              View Technical Details
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
      <ContactFormDialog open={contactOpen} onOpenChange={setContactOpen} />
    </PageContent>
  );
}
